module.exports = __webpack_public_path__ + "vfn-assets/img/logo-smile-fly-c.75b4f373.svg";